<template>
    <v-dialog v-model="show" no-click-animation persistent width="600">
        <div class="AgentSetting">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('freeSwitchSetting') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar" ref="contentDialog">
                <table>
                    <thead>
                    <tr>
                        <th>{{ $f.tc('key') }}</th>
                        <th>{{ $f.tc('value') }}</th>
                        <th>{{ $f.tc('playingCondition') }}</th>
                        <th v-if="isEdit"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, i) in itemList" :key="i">
                        <td>
                            <v-text-field
                                outlined
                                v-model="item.key"
                                class="input-custom"
                                style="width: 100%"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="item.value"
                                class="input-custom"
                                style="width: 100%"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="item.playing_condition"
                                class="input-custom"
                                style="width: 100%"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td v-if="isEdit">
                            <v-btn icon class="mx-0" @click.stop="deleteItem(i)">
                                <img src="/img/delete-blue.svg" alt="icon-delete"
                                     style="transform: scale(1.3); padding-left: 1px">
                            </v-btn>
                        </td>
                    </tr>
                    <!--New variable-->
                    <tr v-if="isEdit">
                        <td>
                            <v-text-field
                                outlined
                                v-model="key"
                                class="input-custom"
                                @keypress.enter="addItem"
                                :placeholder="$f.tc('key')"
                                style="width: 100%"
                                ref="NewKeyVariable"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="value"
                                class="input-custom"
                                @keypress.enter="addItem"
                                :placeholder="$f.tc('value')"
                                style="width: 100%"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="playingCondition"
                                class="input-custom"
                                @keypress.enter="addItem"
                                :placeholder="$f.tc('value')"
                                style="width: 100%"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-btn icon class="mx-0" @click.stop="addItem">
                                <img src="/img/add-blue.svg" alt="icon-delete" style="transform: scale(1.4);">
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer" v-if="isEdit">
                <div class="btn-custom"
                     @click="saveList">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import {mapState} from "vuex";
import lodash from "lodash";
import AgentService from "@/services/agent.service";
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin.vue";

export default {
    name: "AgentSetting",
    mixins: [DialogPromiseMixin],
    data() {
        return {
            key: '',
            value: '',
            playingCondition: '',
            itemList: [],
            originalItemMap: [],
        }
    },
    computed: {
        ...mapState({
            fsSetting: state => state.agent.fs_setting
        }),
        isEdit() {
            return AgentService.isEditable()
        },
    },
    methods: {
        loadFsSettingList() {
            this.itemList = lodash.orderBy(this.$utils.cloneObject(this.fsSetting.value), 'key')
            this.originalItemMap = this.loadOriginalItemMap()
        },
        loadOriginalItemMap() {
            let map = []
            for (let item of this.fsSetting.value) {
                map.push({
                    key: item.key,
                    value: item.value,
                    playing_condition: item.playing_condition
                })
            }
            return map
        },
        open() {
            this.key = ''
            this.value = ''
            this.playingCondition = ''
            this.show = true
            this.loadFsSettingList()
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        addItem() {
            if (this.nameIsEmpty()) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('key')}))
                return
            }
            if (this.valueIsEmpty()) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('value')}))
                return
            }
            if (this.nameIsExist()) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicate', {
                    key: this.$f.tc('key'),
                    value: this.key
                }))
                return
            }
            this.itemList.push({
                key: this.key,
                value: this.value,
                playing_condition: this.playingCondition
            })
            this.scrollBottom()
            this.key = ''
            this.value = ''
            this.playingCondition = ''
            this.$refs.NewKeyVariable.$el.focus()
        },
        nameIsEmpty() {
            return !this.key
        },
        valueIsEmpty() {
            return !this.value
        },
        nameIsExist() {
            let item = this.itemList.find(item => (item.key === this.key.trim()) && (item.playing_condition === this.playingCondition.trim()))
            return !!item
        },
        deleteItem(index) {
            this.itemList.splice(index, 1)
            this.$forceUpdate()
        },
        saveList() {
            if (this.validateItemList() && !lodash.isEqual(this.itemList, this.originalItemMap)) {
                this.appendPlayingCondition()
                this.$store.dispatch(this.$actionTypes.agent.UPDATE_FS_SETTING, {
                    id: this.fsSetting.id,
                    value: this.itemList
                }).then(() => {
                    this.close()
                })
            }
        },
        scrollBottom() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.contentDialog.scrollTo({
                        top: this.$refs.contentDialog.scrollHeight
                    })
                })
            })
        },
        validateItemList() {
            this.trimItemList()
            // check empty
            for (let item of this.itemList) {
                for (let key in item) {
                    if (key !== 'playing_condition' && !item[key].trim()) {
                        this.$appService.toastError(this.$f.tc('fieldItemEmpty'))
                        return false
                    }
                }
            }

            // check duplicate
            let set = new Set(this.itemList.flatMap(i => `${i.key}-${i.playing_condition}`))
            if (set.size !== this.itemList.length) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicateExist', {key: this.$f.tc('key')}))
                return false
            }

            return true
        },
        trimItemList() {
            this.itemList.map(function (item) {
                for (let key in item) {
                    item[key] = item[key].trim()
                }
            })
        },
        appendPlayingCondition() {
            this.itemList.map(function (item) {
                if (!item['playing_condition']) {
                    item['playing_condition'] = ''
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.AgentSetting {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        padding: 12px;
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }

    .btn-custom {
        margin-right: 8px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}


table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    tr {
        border-bottom: 1px solid #96add0;
    }

    tr {
        td {
            padding: 0 6px;

            &:first-child {
                padding-left: 12px;
            }
        }
    }
}

.error-message {
    color: red;
    margin-top: 5px;
    font-size: 13px;
    font-family: "open sans", serif;
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-input--selection-controls {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}
</style>
